import { Switch } from "@xola/ui-kit";
import { FormField, TextareaField } from "common";
import React from "react";
import { Form } from "../Common/Form";

interface TermsFormProps {
    values: any;
    setFieldValue: (key: string, value: boolean) => void;
}

export const TermsForm = ({ values, setFieldValue }: TermsFormProps) => {
    return (
        <Form>
            <fieldset>
                <div className="flex max-w-[560px] flex-col space-y-5">
                    <FormField
                        name="termsHuman"
                        label="Human Friendly"
                        tooltip="A summarized version of the full legal text that is easy for your customers to understand"
                    >
                        <TextareaField rows={6} />
                    </FormField>
                    <FormField
                        name="termsLegal"
                        label="Full Legal Text"
                        tooltip="This is usually the legal document that you want your customers to agree to when booking"
                    >
                        <TextareaField isRequired rows={6} />
                    </FormField>

                    <div className="flex items-center space-x-2">
                        <Switch
                            size="medium"
                            isChecked={values.forceAgree}
                            onChange={(value: boolean) => setFieldValue("forceAgree", value)}
                        />
                        <h5>Force customer to agree in order to complete the purchase</h5>
                    </div>
                </div>
            </fieldset>
        </Form>
    );
};
